import React from 'react'
 
const cases = props =>{
   return(
        <section className="st-section">
            <div className="st-container">
                <div className="ms-width">
                    <div className="st-wrap">
                        <div className="st-box">
                            <h2 className="heading5 text-center">Cases <span className="text-color2">Solved</span></h2>
                            <h3 className="heading5 text-center">197</h3>
                        </div>
                        <div className="st-box">
                            <h2 className="heading5 text-center">Cases <span className="text-color2">Approved</span></h2>
                            <h3 className="heading5 text-center">187</h3>
                        </div>
                        <div className="st-box">
                            <h2 className="heading5 text-center"> <span className="text-color2">Visitors</span></h2>
                            <h3 className="heading5 text-center">356</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   )
}

export default cases;